// @flow

import { isEmpty } from 'lodash';
import { cmsAxios } from './axios-config';
import CustomError from '../utils/error';

const { REACT_APP_CMS_URL } = process.env;

const login = (formdata: { username: string, password: string }) => {
  if (isEmpty(REACT_APP_CMS_URL)) throw new CustomError('Empty URL');

  const data = { identifier: formdata.username, password: formdata.password };

  return cmsAxios.post('/auth/local', data);
};

export const resetPasswordAPI = (formdata: {
  username: string,
  otp: string,
  password: string,
}) => {
  if (isEmpty(REACT_APP_CMS_URL)) throw new CustomError('Empty URL');
  const data = {
    username: formdata.username,
    otp: formdata.otp,
    password: formdata.password,
  };

  return cmsAxios.post('/authentication/reset-password', data);
};

export const changePasswordAPI = (formdata: {
  username: string,
  oldPassword: string,
  newPassword: string,
}) => {
  if (isEmpty(REACT_APP_CMS_URL)) throw new CustomError('Empty URL');

  const data = {
    username: formdata.username,
    oldPassword: formdata.oldPassword,
    newPassword: formdata.newPassword,
  };
  return cmsAxios.post('/authentication/change-password', data);
};

export const requestPasswordReset = (email: string) => {
  if (isEmpty(REACT_APP_CMS_URL)) throw new CustomError('Empty URL');

  const data = { email };

  return cmsAxios.post('/authentication/forgot-password', data);
};

export default login;

